export const isScrollOffsetMoreThanScreenHeight = (offset?: number) => {
  if (!offset) return false;
  return offset > window.innerHeight;
};

export const handleScrollToTop = (element: HTMLDivElement | null) => {
  if (!element) return;
  element.scroll({ behavior: 'smooth', top: 0 });
};
